import { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import 'sweetalert2/src/sweetalert2.scss';
import {
  fetchUserFields,
  setPlaybackFlags,
  setPlayingDocumentId
} from '../../../../redux/actions/app-actions';
import {
  setAiFilter,
  setFilterByThumbs,
  setMyFilter,
  setFlagFilters,
  setPdfFlags,
  setSharedFilter,
  setTypeFilter
} from '../../../../redux/actions/pdf-actions';
import {
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  setIsSelectedFlags,
  setPlayResource,
  setPlayerDocument,
  setPlayerFlag,
  setShowSkipButton
} from '../../../../redux/actions/player-actions';
import { handleDeleteFlags } from '../../../../utils/flag';
import { displayNotification } from '../../../../utils/utils';
import ConfirmationDeleteModal from '../../../flags/components/ConfirmationDeleteModal';
import { initializePollyProcess } from '../../../flags/components/pollyProcess';
import RightSideSkeleton from './RightSideSkeleton';
import FlagRowHeaderInPdfViewer from '../flag-row/FlagRowHeaderInPdfViewer';
import FlagsRightSideHeader from './FlagsRightSideHeader';
import '../../styles/pdfViewer.css';

const FlagsRightSide = ({
  documentUrl,
  groupedFlagsByText,
  selectedText,
  selectedFlag,
  onScrollToText,
  setIsSelectedFlags1,
  setPlayerFlag1,
  setPlayResource1,
  setPlayerDocument1,
  setPlayingDocumentId1,
  setDisableSkipBackButton1,
  setPlaybackFlags1,
  setDisableSkipAheadButton1,
  handleRefreshPdfViewer,
  setFilterByThumbs,
  filterByThumbs,
  userFields,
  instance,
  setMyFilter,
  setAiFilter,
  setSharedFilter,
  preserveFiltersIfExist,
  setTypeFilter,
  typeFilter,
  citationData,
  podcastUrl,
  expand,
  handleClickExpand,
  handleClosePdfViewer,
  handleShareModalInit,
  uniqueSharers,
  unhighlightedFlags,
  isLoadingFilters,
  setIsLoadingFilters,
  aiFilter,
  setFlagFilters,
  isPersonalPodcast,
  isMobileWidth,
  isFromPdfViewerPage,
  exportNotes
}) => {
  const divRefs = useRef([]);
  const [clickMyFlags, setClickMyFlags] = useState(true);
  const [clickSharedFlags, setClickSharedFlags] = useState(1);
  const [flagsToShowOnRight, setFlagsToShowOnRight] = useState([]);
  const [selectFlagsBtn, setSelectFlagsBtn] = useState({
    isActive: false
  });

  const [hiddenSelectionCheckbox, setHiddenSelectionCheckbox] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);
  const [
    openConfirmationDeleteFlagModal,
    setOpenConfirmationDeleteFlagModal
  ] = useState(false);
  const [firstFlag, setFirstFlag] = useState(0);
  const [clickedFlag, setClickedFlag] = useState(null);

  const transformObjectToArray = (groupedFlagsArray) => {
    let array = Object.entries(groupedFlagsArray).map(([key, value]) => ({
      text: key,
      flags: value
    }));
    return array;
  };

  const setFisrtFlag = (groupedFlagsArray) => {
    let array = transformObjectToArray(groupedFlagsArray);
    let array1 = array.flatMap((item) => item.flags);
    let firstMineFlag = array1.find((n) => n.isMine);
    setFirstFlag(JSON.stringify(firstMineFlag));
  };

  const handleClickFlag = (flag, text) => {
    setClickedFlag(flag.flagId);
    const messageData = {
      text,
      pageStart: flag.pageStart,
      flagId: flag.flagId
    };

    window.parent.postMessage(messageData);
  };

  const handleFilter = (type) => {
    if (type === 'my') {
      setClickMyFlags(!clickMyFlags);
      setMyFilter(!clickMyFlags);
      setSharedFilter(clickSharedFlags);
      setAiFilter(aiFilter);
      setTypeFilter('my');
      initFetchFlags(
        documentUrl,
        type,
        !clickMyFlags,
        mapSharedToIsShared(),
        aiFilter
      );
      setFlagFilters({ isMine: !clickMyFlags });
    } else if (type === 'shared') {
      const shouldDisplaySharedFlags =
        clickSharedFlags === 1 || clickSharedFlags === 2 ? 0 : 1;
      setClickSharedFlags(shouldDisplaySharedFlags);
      setSharedFilter(shouldDisplaySharedFlags);
      setMyFilter(clickMyFlags);
      setAiFilter(aiFilter);
      setTypeFilter('shared');
      if (clickSharedFlags === 1 || clickSharedFlags === 2) {
        localStorage.removeItem('listOfUsers');
      }
      initFetchFlags(
        documentUrl,
        type,
        clickMyFlags,
        clickSharedFlags === 1 || clickSharedFlags === 2 ? false : true,
        aiFilter
      );
      setFlagFilters({ isShared: shouldDisplaySharedFlags !== 0 });
    } else if (type === 'ai') {
      if (!aiFilter) {
        if (filterByThumbs) {
          setFilterByThumbs(false);
          localStorage.removeItem('listOfTags');
        }
      }
      setMyFilter(clickMyFlags);
      setSharedFilter(clickSharedFlags);
      setAiFilter(!aiFilter);
      setTypeFilter('ai');
      initFetchFlags(
        documentUrl,
        type,
        clickMyFlags,
        mapSharedToIsShared(),
        !aiFilter
      );
      setFlagFilters({ isAiFlags: !aiFilter });
    }
  };

  const mapSharedToIsShared = () => {
    if (clickSharedFlags == 0) {
      return false;
    } else {
      return true;
    }
  };

  const initFetchFlags = async (
    documentUrl,
    myOrSharedFilter,
    myF,
    sharedF,
    aiF
  ) => {
    await preserveFiltersIfExist(
      documentUrl,
      podcastUrl,
      myOrSharedFilter,
      myF,
      sharedF,
      aiF
    );
  };

  const handleSelectionFlagsBtn = () => {
    setHiddenSelectionCheckbox(!hiddenSelectionCheckbox);
    if (!hiddenSelectionCheckbox) {
      setIsSelectedFlags1(false);
      setSelectedItems([]);
    }
    setSelectFlagsBtn({ isActive: !selectFlagsBtn.isActive });
  };

  const handleItemSelect = (flag) => {
    let itemId = flag.flagId;
    if (selectedItems.includes(flag)) {
      setSelectedItems(selectedItems?.filter((n) => n.flagId !== itemId));
    } else {
      setSelectedItems([...selectedItems, flag]);
    }
  };

  const handlePlayFlagsActionBtn = (e) => {
    if (selectedItems.length > 0) {
      setIsSelectedFlags(true);
      initializePollyProcess(e, selectedItems, true, handleFlagPlay);
    }
  };

  const handleConfirmationDeleteOpen = (e, flags) => {
    e.stopPropagation();
    setOpenConfirmationDeleteFlagModal(true);
    setSelectedItems(flags);
  };

  const closeConfirmationDeleteModal = () => {
    setOpenConfirmationDeleteFlagModal(false);
  };

  const handleConfirmationDelete = async () => {
    try {
      await handleDeleteFlags(selectedItems);

      setOpenConfirmationDeleteFlagModal(false);
      setSelectedItems([]);
      await initFetchFlags(
        documentUrl,
        typeFilter,
        clickMyFlags,
        mapSharedToIsShared(),
        aiFilter
      );
    } catch (error) {
      // Handle delete error
      console.error(error);
      setOpenConfirmationDeleteFlagModal(false);
      if (error !== 'SPECIAL_FLAGS') {
        displayNotification(`<p class="contentModal">${error.message}</p>`, {
          title: '<div class="titleModal">Delete Failed</div>',
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: true
        });
      }
    }
  };

  const handleFlagPlay = async (listOfFlags) => {
    await setPlayerDocument1('');
    await setPlayingDocumentId1(null);
    await setPlayerFlag1(listOfFlags[0]);
    await setPlaybackFlags1(listOfFlags);
    await setPlayResource1('pdfviewer');
    if (listOfFlags.length > 1) {
      await setDisableSkipAheadButton1(false);
      await setDisableSkipBackButton1(false);
    } else {
      await setDisableSkipAheadButton1(true);
      await setDisableSkipBackButton1(true);
    }
  };

  useEffect(() => {
    if (selectedFlag !== null && divRefs.current[selectedFlag]) {
      setClickedFlag(selectedFlag);
      divRefs.current[selectedFlag].scrollIntoView({ behavior: 'smooth' });
    }
  }, [selectedFlag]);

  useEffect(() => {
    setFlagsToShowOnRight(groupedFlagsByText);
    setFisrtFlag(groupedFlagsByText);
  }, [groupedFlagsByText]);

  return (
    <>
    <div
      id="right_side"
      style={{
        flex: '25%',
        height: isMobileWidth ? '50vh' : '100vh',
        padding: '0 20px',
        overflowY: 'scroll',
        background: isMobileWidth
          ? 'transparent'
          : 'linear-gradient(170deg, rgb(3 19 65) 0%, rgb(6, 6, 6) 18%, rgba(0, 0, 6, 1) 50%, rgb(3, 21, 75) 95%)',
        color: '#ccc',
        fontWeight: 100,
        fontSize: 14
      }}
    >
      {!isMobileWidth && !isFromPdfViewerPage && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            /*marginTop: this.props.expand ? '15px' : 0*/ marginRight: '-20px'
          }}
        >
          <ButtonGroup variant="outlined" aria-label="outlined button group">
            <Button
              style={{
                borderBottomLeftRadius: '12px',
                borderColor: 'var( --color-brand24-purple)'
              }}
              onClick={handleClickExpand}
            >
              {expand ? 'Document View' : 'Full Screen'}
            </Button>
            <Button
              style={{
                borderBottomRightRadius: '12px',
                borderColor: 'var( --color-brand24-purple)'
              }}
              onClick={handleClosePdfViewer}
            >
              Close
            </Button>
          </ButtonGroup>
        </div>
      )}

      {instance === null && <RightSideSkeleton isMobileWidth={isMobileWidth} />}
      {instance !== null && (
        <>
          <FlagsRightSideHeader
            handleFilter={handleFilter}
            clickMyFlags={clickMyFlags}
            clickSharedFlags={clickSharedFlags}
            clickAiFlags={aiFilter}
            selectFlagsBtn={selectFlagsBtn}
            handleSelectionFlagsBtn={handleSelectionFlagsBtn}
            selectedItems={selectedItems}
            handlePlayFlagsActionBtn={handlePlayFlagsActionBtn}
            hiddenSelectionCheckbox={hiddenSelectionCheckbox}
            handleSelectedDelete={handleConfirmationDeleteOpen}
            setFlagsToShowOnRight={setFlagsToShowOnRight}
            groupedFlagsByText={groupedFlagsByText}
            instance={instance}
            documentUrl={documentUrl}
            podcastUrl={podcastUrl}
            handleShareModalInit={handleShareModalInit}
            setClickSharedFlags={setClickSharedFlags}
            uniqueSharers={uniqueSharers}
            setClickAiFlags={setAiFilter}
            isLoadingFilters={isLoadingFilters}
            setIsLoadingFilters={setIsLoadingFilters}
            isPersonalPodcast={isPersonalPodcast}
            exportNotes={exportNotes}
            isFromPdfViewerPage={isFromPdfViewerPage}
          />
  
          {Object.entries(flagsToShowOnRight).map(([text, notesList]) => (

            <div
              ref={(el) => (divRefs.current[notesList[0].noteId] = el)}
              key={text}
              onClick={() => {
                handleClickFlag(notesList[0], text);
                onScrollToText(text);
              }}
              className={`flag ${
                clickedFlag === notesList[0].noteId ? 'right-flag-clicked' : ''
              }`}
            >
              <FlagRowHeaderInPdfViewer
                key={text}
                handleFlagPlay={handleFlagPlay}
                setIsSelectedFlags1={setIsSelectedFlags1}
                handleSelectedDelete={handleConfirmationDeleteOpen}
                firstMineFlag={firstFlag}
                handleRefreshPdfViewer={handleRefreshPdfViewer}
                userFields={userFields}
                flagsList={notesList}
                handleItemSelect={handleItemSelect}
                hiddenSelectionCheckbox={hiddenSelectionCheckbox}
                citationData={citationData}
                unhighlightedFlags={unhighlightedFlags}
                isPersonalPodcast={isPersonalPodcast}
                isFromPdfViewerPage={isFromPdfViewerPage}
              />

            </div>

          ))}
          {!isFromPdfViewerPage && citationData?.author &&
            citationData?.author !== '' &&
            !citationData.author.toLowerCase().includes('various') && (
              <div
                style={{ color: '#fff', marginTop: '10px', fontWeight: 600 }}
              >
                Citation: {citationData.author}
                {citationData?.year !== null
                  ? `, (${citationData.year}).`
                  : '.'}{' '}
                {citationData.title && <em>{`${citationData.title}. `}</em>}
                {citationData.location !== null &&
                  citationData.location !== undefined &&
                  `${citationData.location}.`}{' '}
                {citationData.publisher && `${citationData.publisher}`}
              </div>
            )}
        </>
      )}
      {openConfirmationDeleteFlagModal && (
        <ConfirmationDeleteModal
          open={openConfirmationDeleteFlagModal}
          flags={selectedItems}
          onCancel={closeConfirmationDeleteModal}
          onConfirm={handleConfirmationDelete}
        />
      )}
    </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsSelectedFlags1: async (value) => {
      await dispatch(setIsSelectedFlags(value));
    },
    setPlayerFlag1: async (value) => {
      await dispatch(setPlayerFlag(value));
    },
    setPlayerDocument1: async () => {
      await dispatch(setPlayerDocument(''));
    },
    setPlayingDocumentId1: async () => {
      await dispatch(setPlayingDocumentId(null));
    },
    setPlaybackFlags1: async (array) => {
      await dispatch(setPlaybackFlags(array));
    },
    setDisableSkipAheadButton1: async (value) => {
      await dispatch(setDisableSkipAheadButton(value));
    },
    setDisableSkipBackButton1: async (value) => {
      await dispatch(setDisableSkipBackButton(value));
    },
    setShowSkipButton1: async (value) => {
      await dispatch(setShowSkipButton(value));
    },
    setPlayResource1: async (value) => {
      await dispatch(setPlayResource(value));
    },
    setFilterByThumbs: async (value) => {
      await dispatch(setFilterByThumbs(value));
    },
    getUserFields: async (token) => {
      await dispatch(fetchUserFields(token));
    },
    setPdfFlags: async (value) => {
      await dispatch(setPdfFlags(value));
    },
    setMyFilter: async (value) => {
      await dispatch(setMyFilter(value));
    },
    setSharedFilter: async (value) => {
      await dispatch(setSharedFilter(value));
    },
    setAiFilter: async (value) => {
      await dispatch(setAiFilter(value));
    },
    setTypeFilter: async (value) => {
      await dispatch(setTypeFilter(value));
    },
    setFlagFilters: async (value) => {
      await dispatch(setFlagFilters(value));
    }
  };
};

const mapStateToProps = (state) => ({
  userFields: state.app.userFields,
  filterByThumbs: state.pdf.filterByThumbs,
  myFilter: state.pdf.myFilter,
  sharedFilter: state.pdf.sharedFilter,
  aiFilter: state.pdf.aiFilter,
  typeFilter: state.pdf.typeFilter
});

export default connect(mapStateToProps, mapDispatchToProps)(FlagsRightSide);
